import {DriverContactFormServiceTypeEnum} from '@/services/api-clients';


export function driverContactFormServiceTypeColorFilter(type: DriverContactFormServiceTypeEnum) {
  switch (type) {
    case DriverContactFormServiceTypeEnum.Taxi: return 'yellow accent-4';
    case DriverContactFormServiceTypeEnum.Courier: return 'primary';
    case DriverContactFormServiceTypeEnum.BikeService: return 'success';
    case DriverContactFormServiceTypeEnum.Unknown: return '';
  }
}
